import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ReactComponent as Logo } from '../../../../assets/images/logos/logo_privacy.svg';

interface OnboardingDialogProps {
  open: boolean;
  onAction: () => void;
  title?: string;
  description?: string;
  description2?: string;
  actionLabel?: string;
  children?: React.ReactNode;
}

const OnboardingDialog: React.FC<OnboardingDialogProps> = ({
  open,
  onAction,
  title,
  description,
  description2,
  actionLabel = 'Continue',
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onAction();
        }
      }}
      maxWidth={false}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 4,
          background: '#fff',
          boxShadow: 8,
          minWidth: { xs: '90vw', sm: 600, md: 850 },
          maxWidth: { xs: '90vw', sm: 600, md: 850 },
          minHeight: { xs: 300, sm: 350, md: 370 },
          maxHeight: { xs: 300, sm: 350, md: 370 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2100,
          p: { xs: 2, sm: 4, md: 6 },
        },
      }}
    >
      <DialogContent
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 0,
        }}
      >
         <Box
          mb={2}
          sx={{
            width: {
              xs: '70%',
              sm: '60%',
              md: '40%',
            },
            display: 'flex',
            justifyContent: 'center',
            mb: {xs: '16px', sm: '20px', md: '30px'}
          }}
        >
          <Logo
            style={{
              width: '85%',
              maxWidth: '308px',
              height: 'auto',
              display: 'block',
              marginTop: '16px',
              fill: '#32174E',
            }}
          />
          </Box>
        {title && (
          <Typography
            variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: { xs: 12, sm: 16, md: 18 },
            fontFamily: 'InterBold',
            color: '#222',
            textAlign: 'center',
            mb: {xs: 4, sm: 5, md: 6},
          }}
        >
          {title}
        </Typography>
        )}
        {description && (
          <Typography
            sx={{
            fontSize: { xs: 12, sm: 16, md: 18 },
            color: '#444',
            fontWeight: 400,
            fontFamily: 'InterMedium',
            lineHeight: {xs: 1, sm: 1, md: 1.4},
            textAlign: 'center',
            mb: description2 || children ? 3 : 9,
            maxWidth: "85%",
          }}
        >
            {description}
          </Typography>
        )}
        {description2 && (
          <Typography
            sx={{
            fontSize: { xs: 12, sm: 16, md: 18 },
            color: '#444',
            fontWeight: 400,
            fontFamily: 'InterMedium',
            lineHeight: {xs: 1, sm: 1, md: 1.4},
            textAlign: 'center',
            mb: 3,
            maxWidth: "80%",
          }}
        >
            {description2}
          </Typography>
        )}
        {children}

        <Button
          variant="contained"
          sx={{
            background: '#4361EE',
            color: '#fff',
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: 20,
            width: "35%",
            height: 40,
            boxShadow: 2,
            mb: {xs: 3},
            '&:hover': {
              background: '#2749C4',
              color: '#fff',
              boxShadow: 4,
            },
          }}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingDialog;